import {
  AwardTeamMemberData,
  requestAwardTeamConfig,
} from 'modals/ShiftModal/src/views/AwardTeamMemberView/AwardTeamMemberView.constants';
import { useShiftModalDataContext } from 'modals/ShiftModal/ShiftModalProvider.data.context';
import { BiddableShiftStatus } from 'components/Tags/Tags.types';
import { useSSFBehaviors } from 'hooks';
import { FC, MouseEventHandler, useContext, useEffect, useState } from 'react';
import { GQLAPIContextType } from 'types/common.types';
import { Order } from 'types/graphql';
import { createGQLDataContext } from 'utils/createDataContext';
import { getShiftBiddingStatus } from 'utils/shiftStatus';

export const AwardTeamMemberContext = createGQLDataContext({});

const AwardTeamMemberInnerProvider: FC<{ order: Order }> = ({ children, order }) => {
  const [biddingStatus, setBiddingStatus] = useState<Nullable<BiddableShiftStatus>>(null);

  const [values, { data, ...rest }] = useSSFBehaviors(
    requestAwardTeamConfig({
      orderId: order.relayId,
    }),
  );

  const orderWithBids = data?.order;

  useEffect(() => {
    if (!!orderWithBids && !biddingStatus) {
      setBiddingStatus(
        getShiftBiddingStatus({
          status: orderWithBids.status.value,
          biddable: orderWithBids.biddable,
          biddingTimeEndsAt: orderWithBids.biddingTimeEndsAt,
          awardingTimeStartsAt: orderWithBids.awardingTimeStartsAt,
          bids: orderWithBids.bids,
        }),
      );
    }
  }, [biddingStatus, orderWithBids]);

  return (
    <AwardTeamMemberContext.Provider
      value={{
        values,
        data,
        biddingStatus,
        ...rest,
      }}
    >
      {children}
    </AwardTeamMemberContext.Provider>
  );
};

export const AwardTeamMemberProvider: FC = ({ children }) => {
  const { data } = useShiftModalDataContext();
  const order = data?.order;

  if (!order) return null;

  return <AwardTeamMemberInnerProvider order={order}>{children}</AwardTeamMemberInnerProvider>;
};

export const useAwardTeamMemberContext = (): GQLAPIContextType<AwardTeamMemberData> & {
  onReset: MouseEventHandler<HTMLDivElement>;
  data: AwardTeamMemberData;
  biddingStatus: Nullable<BiddableShiftStatus>;
} => useContext(AwardTeamMemberContext);
